import React from 'react';

import { StyledDeviceStoreAvailability } from './DeviceStoreAvailability.styles';

import { DeviceStoreAvailabilityProps } from './DeviceStoreAvailability.types';

const DeviceStoreAvailability = ({
  deviceStoreDetailsList,
  label,
  onDeviceStoreButtonClick = () => {},
  renderLink,
  componentClassname = 'device-store-availability',
  customClassnames = '',
  customStyle = '',
  ...props
}: DeviceStoreAvailabilityProps) => {
  const handleClick = (deviceStoreName: string) => {
    onDeviceStoreButtonClick(deviceStoreName);
  };

  return (
    <StyledDeviceStoreAvailability
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      <div className={`${componentClassname}__label`}>{label}</div>
      <ul className={`${componentClassname}__slot-ul`}>
        {deviceStoreDetailsList?.map(({ name, slot, url }) => (
          <li
            key={name}
            className={`${componentClassname}__slot-li ${componentClassname}__slot-li--${name}`}
            onClick={() => handleClick(name)}
          >
            {renderLink ? (
              renderLink({
                href: url,
                children: slot,
                target: '_blank',
                rel: 'noreferrer',
              })
            ) : (
              <a href={url} target="_blank" rel="noreferrer">
                {slot}
              </a>
            )}
          </li>
        ))}
      </ul>
    </StyledDeviceStoreAvailability>
  );
};
DeviceStoreAvailability.displayName = 'DeviceStoreAvailability';

export default DeviceStoreAvailability;
